import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class RebalanceMovimentacaoInstalacao {
    async getWithFilter(filters: any) {
        return await api.get<IPayload>(
            `${resources.rebalanceMovimentacaoInstalacao}/GetWithFilter/${ToQueryString(filters)}`
        );
    }

    async update(data: any) {
        return await api.put<any>(`${resources.rebalanceMovimentacaoInstalacao}/Update`, data);
    }

    async create(data: any) {
        return await api.post(`${resources.rebalanceMovimentacaoInstalacao}/Create`, data);
    }

    async upload(data: any) {
        return await api.post(`${resources.rebalanceMovimentacaoInstalacao}/Upload`, data);
    }

    async inativar(data: any) {
        return await api.put(`${resources.rebalanceMovimentacaoInstalacao}/Inativar`, data);
    }

    async getStatusArquivo(data: any) {
        return await api.get(`${resources.rebalanceMovimentacaoInstalacao}/GetStatusArquivo/${ToQueryString(data)}`);
    }
}

export default new RebalanceMovimentacaoInstalacao();
